import {
  Dialog,
  Button,
  IconButton,
  Close,
  CircularProgress,
  Tooltip,
  Box,
  Typography,
} from "mpulse-design-system";

import { forwardRef } from "react";

const ArchiveConfirmationDialog = ({
  loading,
  open,
  callback,
  departmentName,
}) => {
  const title = "Archive " + departmentName;
  const message =
    "By archiving '" +
    departmentName +
    "', both the department and any related audio files will no longer be available for use in any IVR calls. Archived departments can be restored.";

  const Title = forwardRef(function Title(props, ref) {
    return (
      <div {...props} ref={ref}>
        <Typography
          noWrap
          align="left"
          variant="h1"
          data-testid="alert-dialog-title"
          id="alert-dialog-title"
        >
          {title}
        </Typography>
      </div>
    );
  });

  return (
    <Dialog
      open={open}
      onClose={() => !loading && callback(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      PaperProps={{
        variant: "outlined",
        elevation: 0,
        sx: {
          maxWidth: "684px",
        },
      }}
    >
      <Box sx={{ padding: "40px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              width: "92%",
            }}
          >
            {title.length > 35 ? (
              <Tooltip
                title={title}
                variant="dark"
                placement="bottom"
                arrow={true}
              >
                <Title />
              </Tooltip>
            ) : (
              <Title />
            )}
          </Box>

          {!loading && (
            <Box
              sx={{
                alignSelf: "flex-end",
                pl: "8px",
              }}
            >
              <Tooltip
                title={"Close"}
                variant="dark"
                placement="bottom"
                arrow={true}
              >
                <IconButton onClick={() => callback(false)}>
                  <Close />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        </Box>
        <Box sx={{ pb: "24px", pt: "24px" }}>
          <Typography
            data-testid="alert-dialog-description"
            id="alert-dialog-description"
          >
            {message}
          </Typography>
        </Box>
        <Box>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Box>
                <Button
                  data-testid="cancel-button"
                  color="primary"
                  variant="outlined"
                  size="medium"
                  onClick={() => callback(false)}
                >
                  Cancel
                </Button>
              </Box>
              <Box sx={{ ml: "16px" }}>
                <Button
                  data-testid="confirm-button"
                  color="primary"
                  variant="contained"
                  size="medium"
                  onClick={() => callback(true)}
                  autoFocus
                >
                  Confirm
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default ArchiveConfirmationDialog;
